/** 通知タイプ */
export type NotificationType =
  | "incomingCall"
  | "newMessage"
  | "favorite"
  | "system";

/** 通知エンティティ */
export type Notification = {
  id: string;
  type: NotificationType;
  title: string;
  message: string;
  /** タイプ固有の追加データ（例: senderId, roomId 等） */
  data?: Record<string, string>;
  createdAt: string;
  isRead: boolean;
};

/** 返信通知かどうかを判定するヘルパー */
export const isReplyNotification = (notification: Notification): boolean => {
  return notification.data?.is_reply === "true";
};
